import { AlertTriangle, ScrollText } from 'lucide-react'
import { useAiAuditLogs } from '../../src/hooks/data/useAiUsage'

/** Real, PII-redacted-before-storage audit trail of LLM interactions
 * (ai-engine/app/services/audit_log.py, read via GET /ai/audit-logs). */
export default function AiAuditLogWidget() {
  const { data, isLoading } = useAiAuditLogs(20)
  const entries = data?.entries ?? []

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 lg:col-span-2">
      <div className="flex items-center gap-2 p-4 border-b border-gray-100 dark:border-gray-700">
        <ScrollText className="w-5 h-5 text-blue-600" />
        <h2 className="font-semibold text-gray-800 dark:text-white">AI Audit Log</h2>
        {data && <span className="text-sm text-gray-500">{data.total} recent</span>}
      </div>

      <div className="divide-y divide-gray-100 dark:divide-gray-700 max-h-96 overflow-y-auto">
        {isLoading ? (
          Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="h-14 m-3 rounded-lg bg-gray-100 dark:bg-gray-700/40 animate-pulse" />
          ))
        ) : entries.length === 0 ? (
          <p className="p-4 text-sm text-gray-500">No AI interactions logged yet.</p>
        ) : (
          entries.map((entry) => (
            <div key={entry.id} className="p-3 text-sm">
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-800 dark:text-gray-100">{entry.feature}</span>
                <span className="text-xs text-gray-400">
                  {new Date(entry.timestamp * 1000).toLocaleString()}
                </span>
              </div>
              <p className="mt-1 text-gray-600 dark:text-gray-300 truncate" title={entry.request_preview}>
                {entry.request_preview}
              </p>
              <div className="mt-1 flex items-center gap-2 text-xs text-gray-400">
                <span>{entry.latency_ms.toFixed(0)}ms</span>
                {entry.guardrail_triggered && (
                  <span className="inline-flex items-center gap-1 text-amber-600 dark:text-amber-400">
                    <AlertTriangle className="w-3 h-3" />
                    {entry.guardrail_reasons.join(', ') || 'guardrail triggered'}
                  </span>
                )}
                {entry.pii_detected.length > 0 && (
                  <span className="text-red-500">PII: {entry.pii_detected.join(', ')}</span>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
